import { Component, input, viewChildren } from '@angular/core';
import { IconKlankvoetNormal } from '../../icons/i-klankvoet-normal';
import { IconKlankvoetStom } from '../../icons/i-klankvoet-stom';
import { RidCompressableKlankCard } from '../rid-compressable-klank-card/rid-compressable-klank-card';
import { RidSyllabicKeyboardUtils, TKey } from '../rid-syllabic-keyboard/rid-syllabic-keyboard.utils';

@Component({
  selector: 'rid-syllabic-card',
  imports: [RidCompressableKlankCard, IconKlankvoetNormal, IconKlankvoetStom],
  templateUrl: './rid-syllabic-card.html',
})
export class RidSyllabicCard {
  protected getWrittenText = RidSyllabicKeyboardUtils.getWrittenText.bind(RidSyllabicKeyboardUtils);

  value = input.required<TKey>();
  // Colours rule cards in the stem colour, e.g. in the morfemenbord when a suffix changes the center.
  highlightRule = input(false);

  compressable = viewChildren<RidCompressableKlankCard>('compressable');
}
